export const MAX_DAY_LOGS = 60;


export const minDateLogs = (): Date => {
   const day = new Date().getDate() - MAX_DAY_LOGS;
   return new Date(new Date().setDate(day));
};